var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _path3, _path4, _path5, _path6, _path7, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlue2 = function SvgBlue2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 113,
    viewBox: "0 0 104 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h100a2 2 0 0 1 2 2v109a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 44,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 39,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 54,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 34,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 34,
    width: 22,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 49,
    width: 22,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 15,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 22,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 49,
    width: 18,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 92.632c0-.35.283-.632.632-.632H26v4H8.632A.632.632 0 0 1 8 95.368v-2.736Z",
    fill: "#3869EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DB6F6",
    d: "M26 92h42v4H26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3869EB",
    d: "M68 92h8v4h-8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h19.368c.35 0 .632.283.632.632v2.736a.632.632 0 0 1-.632.632H76v-4Z",
    fill: "#9DB6F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68 98.63a.63.63 0 0 1 .63-.63H76v4h-7.37a.63.63 0 0 1-.63-.63v-2.74ZM68 104.63a.63.63 0 0 1 .63-.63H76v4h-7.37a.63.63 0 0 1-.63-.63v-2.74Z",
    fill: "#3869EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76 98h19.368c.35 0 .632.283.632.632v2.736a.632.632 0 0 1-.632.632H76v-4ZM76 104h19.368c.35 0 .632.283.632.632v2.736a.632.632 0 0 1-.632.632H76v-4Z",
    fill: "#9DB6F6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 59,
    width: 88.687,
    height: 3.59,
    rx: 0.632,
    fill: "#3869EB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 71,
    width: 88.687,
    height: 3.59,
    rx: 0.632,
    fill: "#3869EB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 21,
    width: 88,
    height: 6,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 65,
    width: 14,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 65,
    width: 5,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 65,
    width: 6,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 65,
    width: 5,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 65,
    width: 9,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 65,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 65,
    width: 9,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 77,
    width: 14,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 77,
    width: 5,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 77,
    width: 6,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 77,
    width: 5,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 77,
    width: 9,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 77,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 77,
    width: 9,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 82,
    width: 9,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 87,
    width: 9,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 82,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 87,
    width: 16,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 82,
    width: 9,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 87,
    width: 9,
    height: 3,
    rx: 0.632,
    fill: "#9DB6F6"
  })));
};

export default SvgBlue2;